module.exports = __webpack_public_path__ + "static/media/melchior_cheese1.6603fbd8.jpg";